module.exports = __webpack_public_path__ + "img/ltkseasonal-4x.e9dd26a.jpg";